export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сүзгілер"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Күй"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дүкен"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Есеп"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қолдану"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Барлығын тазалау"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Күйді таңдаңыз"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дүкенді таңдаңыз"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Шот нөмірін енгізіңіз"])}
}